//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum StoreProductsTableFilterColumn {
  hasMsProduct = 0,
  /** Only for Wildberries products. */
  isTrashed = 1,
  /** Товар с тем же артикулом есть на Ozon. */
  onOzon = 2,
  /** Товар с тем же артикулом есть на Wildberries. На вкладке Wildberries игнорируется. */
  onWb = 3,
  /** Товар с тем же артикулом есть на Яндекс Маркете. На вкладке Яндекс Маркета игнорируется. */
  onYandexMarket = 4,
  /** Товар с тем же артикулом есть в МоёмСкладе. */
  onMoySklad = 5
}
